import yup from '../../../config/yup';

export const lingkAdapterWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('lingkAdapterWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  onError: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    acceptInvalidCerts: yup.boolean(),
    rootUrl: yup.string(),
    path: yup.string().required('Path is required'),
    url: yup.string(),
    secret: yup.string(),
    sleepInMilliSeconds: yup.number().typeError('Sleep In MilliSeconds must be a number'),
  }),
});
